import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { showModal } from "../statusModal/statusModal";
import {
  createAdsWhitelistAPI,
  deleteAdsWhitelistAPI,
  fetchAdsWhitelistAPI,
} from "./adsWhitelistAPI";

const initialState = {
  items: [],
  total: 0,
  fetchStatus: "idle",
  createStatus: "idle",
  deleteStatus: "idle",
  error: null,
};

export const fetchAdsWhitelist = createAsyncThunk(
  "adsWhitelist/fetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await fetchAdsWhitelistAPI(params);
      return response?.data || {};
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.errorKey || "errors.server.internalError",
      );
    }
  },
);

export const createAdsWhitelistItem = createAsyncThunk(
  "adsWhitelist/create",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await createAdsWhitelistAPI(payload);
      dispatch(
        showModal({
          message: "تمت إضافة العنصر إلى القائمة البيضاء بنجاح",
          status: "success",
        }),
      );
      return response?.data;
    } catch (error) {
      dispatch(
        showModal({
          message: "فشل إضافة العنصر إلى القائمة البيضاء",
          status: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.errorKey || "errors.server.internalError",
      );
    }
  },
);

export const deleteAdsWhitelistItem = createAsyncThunk(
  "adsWhitelist/delete",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      await deleteAdsWhitelistAPI(id);
      dispatch(
        showModal({
          message: "تمت إزالة العنصر من القائمة البيضاء بنجاح",
          status: "success",
        }),
      );
      return id;
    } catch (error) {
      dispatch(
        showModal({
          message: "فشل إزالة العنصر من القائمة البيضاء",
          status: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.errorKey || "errors.server.internalError",
      );
    }
  },
);

const adsWhitelistSlice = createSlice({
  name: "adsWhitelist",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdsWhitelist.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchAdsWhitelist.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.items = Array.isArray(action.payload?.items)
          ? action.payload.items
          : [];
        state.total = Number(action.payload?.total || 0);
      })
      .addCase(fetchAdsWhitelist.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload || "errors.server.internalError";
      })
      .addCase(createAdsWhitelistItem.pending, (state) => {
        state.createStatus = "loading";
        state.error = null;
      })
      .addCase(createAdsWhitelistItem.fulfilled, (state, action) => {
        state.createStatus = "succeeded";
        if (action.payload) {
          state.items = [action.payload, ...state.items];
          state.total = Number(state.total || 0) + 1;
        }
      })
      .addCase(createAdsWhitelistItem.rejected, (state, action) => {
        state.createStatus = "failed";
        state.error = action.payload || "errors.server.internalError";
      })
      .addCase(deleteAdsWhitelistItem.pending, (state) => {
        state.deleteStatus = "loading";
        state.error = null;
      })
      .addCase(deleteAdsWhitelistItem.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        const before = state.items.length;
        state.items = state.items.filter(
          (item) => String(item?._id || "") !== String(action.payload),
        );
        const removedCount = before - state.items.length;
        state.total = Math.max(0, Number(state.total || 0) - removedCount);
      })
      .addCase(deleteAdsWhitelistItem.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload || "errors.server.internalError";
      });
  },
});

export default adsWhitelistSlice.reducer;
